import { createSelector } from 'reselect'

const getPrivateLibraries = state => state.user.extra ? state.user.extra.libraries : []
const user_private_libraries_selector = createSelector(
	[ getPrivateLibraries ],
	privateLibraries => privateLibraries
)

export default user_private_libraries_selector
